import { render, staticRenderFns } from "./batchPrint.vue?vue&type=template&id=52806e2e&scoped=true"
import script from "./batchPrint.vue?vue&type=script&lang=js"
export * from "./batchPrint.vue?vue&type=script&lang=js"
import style0 from "./batchPrint.vue?vue&type=style&index=0&id=52806e2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52806e2e",
  null
  
)

export default component.exports